import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ContactComponent } from './contact.component';
import { ContactRoutingModule } from './contact-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GoogleMapsModule } from '@angular/google-maps';
@NgModule({ 
  imports: [ContactRoutingModule, SharedModule, ReactiveFormsModule, MatInputModule, MatSelectModule, MatCheckboxModule, MatProgressSpinnerModule, GoogleMapsModule],
  declarations: [ContactComponent],
  exports: [ContactComponent]

})
export class ContactModule { }
